import { TabsList, TabsTrigger } from '@/components/ui/tabs'
import { PROPERTY_PAGE_TABS } from '@/lib/property-routes'

/**
 * The property routes' tab row (CAP-1034), shared by `/properties/:id` and
 * `/properties/:id/messages`. Render it inside a `Tabs` whose
 * `onValueChange` reaches each value from that page (`propertyTabPath`).
 */
export function PropertyPageTabList() {
  return (
    <TabsList>
      {PROPERTY_PAGE_TABS.map(tab => (
        <TabsTrigger key={tab.value} value={tab.value}>
          {tab.label}
        </TabsTrigger>
      ))}
    </TabsList>
  )
}
